import React from "react";
import { Activity, Sparkles, Leaf, ArrowRight } from "lucide-react";
import { SERVICES, PHOTOS, SITE } from "@/lib/site-data";

const ICONS = { Activity, Sparkles, Leaf };

export default function Services() {
  return (
    <section id="servicos" className="py-20 md:py-28 bg-stone-50/60" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">O que fazemos</p>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-stone-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Tratamentos pensados para o <span className="text-orange-600">seu corpo.</span>
            </h2>
          </div>
          <a href={SITE.whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="services-cta-btn" className="hidden md:inline-flex items-center gap-2 text-orange-600 font-semibold hover:gap-3 transition-all">
            Falar com a clínica <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon];
            return (
              <article key={s.title} data-testid={`service-card-${idx}`} className="group rounded-3xl overflow-hidden bg-white border border-stone-100 hover:border-orange-200 transition-all hover:-translate-y-1 hover:shadow-[0_18px_40px_-12px_rgba(0,0,0,0.1)]">
                <div className="aspect-[4/3] overflow-hidden bg-stone-100">
                  <img src={PHOTOS[s.image]} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6 md:p-7">
                  <div className="h-11 w-11 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center mb-4">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="text-xl font-bold text-stone-900" style={{ fontFamily: "'Outfit', sans-serif" }}>{s.title}</h3>
                  <p className="mt-2 text-stone-600 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
